import React from "react";
import "./InfoCountry.css";
import china from '../assets/china.png';

const InfoCountry = () => {
    return (
        <div className="info-country">
            <div>
            <h1 className="InfoCountry-title">PAISES LIDERES AGRICOLAS</h1>
            <p className="InfoCountry-paragraph">
                En 2024, China invirtio 2 mil millones de dolares en sustitutos agricolas 
                para evitar suelos alcalinos, logrando incrementar la productividad de sus 
                cosechas en un 68%.
            </p>
            </div>
            <div className="InfoCountry-image"> 
                <img src={china} alt="China" />
            </div>
        </div>
    );
}

export default InfoCountry;  // 👈 Asegúrate de tener esta línea